/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Precise_LocationInputs */

const en_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precise Location`)
};

const es_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación precisa`)
};

const fr_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement précis`)
};

const de_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genauer Standort`)
};

const ja_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正確な位置`)
};

const zh_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精确位置`)
};

const ar_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الموقع الدقيق`)
};

const id_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokasi Tepat`)
};

const it_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione Esatta`)
};

const ru_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точное местоположение`)
};

const pt_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Localização Exata`)
};

const ko_precise_location = /** @type {(inputs: Precise_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정확한 위치`)
};

/**
* | output |
* | --- |
* | "Precise Location" |
*
* @param {Precise_LocationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const precise_location = /** @type {((inputs?: Precise_LocationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Precise_LocationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_precise_location(inputs)
	if (locale === "es") return es_precise_location(inputs)
	if (locale === "fr") return fr_precise_location(inputs)
	if (locale === "de") return de_precise_location(inputs)
	if (locale === "ja") return ja_precise_location(inputs)
	if (locale === "zh") return zh_precise_location(inputs)
	if (locale === "ar") return ar_precise_location(inputs)
	if (locale === "id") return id_precise_location(inputs)
	if (locale === "it") return it_precise_location(inputs)
	if (locale === "ru") return ru_precise_location(inputs)
	if (locale === "pt") return pt_precise_location(inputs)
	return ko_precise_location(inputs)
});